import fetchAllUniversalCustomerRepresentativeSagas from './fetchAllUniversalCustomerRepresentative'
import fetchUniversalCustomerRepresentativeSagas from './fetchUniversalCustomerRepresentative'

// CODE_COMMENTS_11
export default [
  ...fetchAllUniversalCustomerRepresentativeSagas,
  ...fetchUniversalCustomerRepresentativeSagas,
]
